import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import {
  changeStatus,
  userListing,
  userListingDownload,
} from "../Redux/Actions/adminAction";
import Search from "../Components/Layout/Search";
import ShowingResult from "../Components/Layout/ShowingResult";
import Limit from "../Components/Layout/Limit";
import { toast } from "react-toastify";
import Pagination from "../Components/Layout/Pagination";
import * as XLSX from "xlsx";
import logo from "../Assets/Images/placeholder 1 .png";
import { io } from "socket.io-client";
import { Modal } from "react-bootstrap";

export default function UserManagement() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector((state) => state.usermgmtData.userList);
  console.log(data, "userList");
  const BASE_URL = process.env.REACT_APP_FILE_BASE_URL;
  const [usersWithLocations, setUsersWithLocations] = useState([]);
  const [page, setpage] = useState("1");
  const [search, setsearch] = useState("");
  const [limit, setlimit] = useState("10");
  const [flag, setflag] = useState(true);
  const [status, setStatus] = useState("");
  const [pageType, setPageType] = useState("");
  const [socket, setSocket] = useState(null);
  const [addresses, setAddresses] = useState({});
  const [showMapModal, setShowMapModal] = useState(false);
  const [selectedUserLocation, setSelectedUserLocation] = useState(null);
  const [mapUrl, setMapUrl] = useState("");

  useEffect(() => {
    dispatch(userListing({ page, search, limit, type: "", status }));
  }, [page, search, limit, flag, status]);

  // const handlechange = (e) => {
  //   console.log(e.target.value);
  //   setPageType(e.target.value);

  //   dispatch(userListing({ page, search, limit, type: e.target.value }));
  // };

  const fetchDataAndExportToExcel = useCallback(async () => {
    try {
      const response = await dispatch(userListingDownload());
      console.log(response);

      const allData = response?.payload?.data?.users;

      const ws = XLSX.utils.json_to_sheet(allData);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      XLSX.writeFile(wb, "exported_data.xlsx", {
        bookType: "xlsx",
        bookSST: false,
        type: "blob",
      });
    } catch (error) {
      console.error("Error fetching or exporting data:", error);
    }
  }, [dispatch]);

 
  useEffect(() => {
    const newSocket = io(process.env.REACT_APP_SOCKET_URL);
    setSocket(newSocket);

    return () => {
      if (newSocket) newSocket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (data?.data?.users) {
      const initializedUsers = data.data.users.map(user => ({
        ...user,
        liveLocation: user.liveLocation || {
          type: "Point",
          coordinates: [0, 0],
          lastLive: null
        }
      }));
      setUsersWithLocations(initializedUsers);
    }
  }, [data]);

  useEffect(() => {
    if (socket && usersWithLocations.length > 0) {
      usersWithLocations.forEach(user => {
        socket.on(`${user._id}_live_location`, (locationData) => {
          setUsersWithLocations(prevUsers => 
            prevUsers.map(u => 
              u._id === user._id 
                ? { ...u, liveLocation: locationData } 
                : u
            )
          );
        });
      });

      return () => {
        usersWithLocations.forEach(user => {
          socket.off(`${user._id}_live_location`);
        });
      };
    }
  }, [socket, usersWithLocations]);

  const handleShowMap = (user) => {
    if (user.liveLocation?.coordinates) {
      const [lng, lat] = user.liveLocation.coordinates;
      if (lat !== 0 && lng !== 0) {
        setSelectedUserLocation({ lat, lng });
        setMapUrl(`https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`);
        setShowMapModal(true);
      } else {
        toast.warning("No valid location data available for this user");
      }
    } else {
      toast.warning("No location data available for this user");
    }
  };

  const formatCoordinates = (coords) => {
    if (!coords || !Array.isArray(coords)) return "-";
    return `${coords[1]?.toFixed(4)}, ${coords[0]?.toFixed(4)}`;
  };

  return (
    <Layout>
      <div className="right-top">
        <div className="heading-top">
          <h2>User Management</h2>
        </div>
        <hr />
        <Container fluid>
          <div className="cmn-top-fields">
            <Row>
              <Col xxl={3} xl={3} lg={4} md={4}>
                <Form.Group>
                  {/* <Form.Control type="search" placeholder="Keyword Search.." /> */}
                  <Search setsearch={setsearch} />
                </Form.Group>
              </Col>
              <Col xxl={3} xl={3} lg={4} md={4}>
                <Form.Select
                  onChange={(e) => setStatus(e.target.value)}
                  aria-label="Default select example"
                >
                  <option value="">All</option>
                  <option value="1">Active</option>
                  <option value="0">Temporary Banned</option>
                </Form.Select>
              </Col>
              <Col
                xxl={6}
                xl={6}
                lg={4}
                md={4}
                className="d-flex justify-content-end align-items-center"
              >
                <div className="cmn-btn">
                  <Link onClick={fetchDataAndExportToExcel}>DOWNLOAD</Link>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
        <hr />
        <Container fluid>
          <div className="product-tab">
            <ul>
              <li>
                <Link to="/UserProfile" className="active-tab">
                  All
                </Link>
              </li>
              <li>
                <Link to="/WorkersUser">Workers</Link>
              </li>
              <li>
                <Link to="/CompanyUser">Company</Link>
              </li>
            </ul>
          </div>
        </Container>
      </div>
      <Container fluid>
        <div className="results-sec">
          <Row>
            <Col lg={6} className="d-flex align-items-center">
              <div className="show-results">
                {" "}
                <ShowingResult page={page} limit={limit} />
              </div>
            </Col>
            <Col lg={6}>
              <div className="select-result d-flex align-items-center justify-content-end">
                <span>Results per page</span> <Limit setlimit={setlimit} />
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      <Container fluid className="px-0">
        <div class="table-responsive">
          <Table size="sm" className="table-cmn">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Profile Image </th>
                <th>Profile Name</th>
                <th>Email</th>
                {/* <th>Profile Image</th> */}
                {/* <th>Position</th> */}
                {/* <th>Location</th>
                <th>Status</th> */}
                <th>Location</th>
                <th>Profile Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.data?.users?.map((user, index) => {
                const serialNumber = (page - 1) * limit + index + 1;
                return (
                  <tr>
                    <td>{serialNumber}</td>
                    <td className="user-img">
                      <img
                        src={
                          user?.profile_image
                            ? `${BASE_URL}${user?.profile_image}`
                            : logo
                        }
                        alt="user"
                      />
                    </td>

                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (user?.role == 0) {
                          navigate(`/WorkersProfile/${user?._id}`, {
                            state: {
                              from: "userMangement",
                            },
                          });
                        } else {
                          navigate(`/CompanyVerifyProfile/${user?._id}`, {
                            state: {
                              from: "userMangement",
                            },
                          });
                        }
                      }}
                    >
                      {" "}
                      {/* <Link to={`/WorkersProfile/${user?._id}`}> */}
                      <b> {user?.full_name || "N/A"}</b>
                      {/* </Link> */}
                    </td>
                    <td>{user?.email || "N/A"}</td>
                    {/* <td className="user-img">
                  <img src={require("../Assets/Images/user.png")} />
                </td> */}
                   <td>
                <div className="address-design">
                  {user?.liveLocation?.coordinates ?  "" : "-"}
                  <button 
                    className="live-btn ms-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShowMap(user);
                    }}
                  >
                    Check Live Location
                  </button>
                </div>
              </td>
                    <td>
                      <div className="select-box">
                        <Form.Select
                          onChange={(e) => {
                            dispatch(
                              changeStatus({
                                userId: user?._id,
                                type: e.target.value,
                              })
                            ).then((res) => {
                              if (res?.payload?.success) {
                                toast.success(res?.payload?.message);
                                setflag(!flag);
                              } else {
                                toast.error(res?.payload?.message);
                              }
                            });
                          }}
                          value={user?.is_active}
                          aria-label="Default select example"
                        >
                          <option value="0">Temporary Banned</option>
                          <option value="1">Active</option>
                        </Form.Select>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          {data?.data?.users?.length == 0 && (
            <div className="no-data-updated">
              <p className="no-data">No data available yet</p>
            </div>
          )}
        </div>
      </Container>

      <Pagination
        totalstuff={data?.data?.totalPages}
        limit={data?.data?.limit}
        setpages={setpage}
        search={search}
      />

        {/* Map Modal */}
            <Modal 
              show={showMapModal} 
              onHide={() => setShowMapModal(false)}
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>Live Location</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {selectedUserLocation && (
                  <div style={{ height: "500px", width: "100%" }}>
                    <iframe
                      title="User Location Map"
                      width="100%"
                      height="100%"
                      frameBorder="0"
                      scrolling="no"
                      marginHeight="0"
                      marginWidth="0"
                      src={mapUrl}
                    ></iframe>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <button 
                  className="btn btn-secondary"
                  onClick={() => setShowMapModal(false)}
                >
                  Close
                </button>
              </Modal.Footer>
            </Modal>
    </Layout>
  );
}
